import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import Button from '../../styleguide/buttons/Button'

const ReloadButton = styled(Button)`
	grid-column: 1;
	place-self: center left;
	.MuiButtonBase-root {
		padding: 0;
	}
`

export const LeftReloadButton = () => {
	const { t } = useTranslation()
	return (
		<ReloadButton
			variant="text"
			underlined={true}
			onClick={() => window.location.reload()}
			className="ott-ltDashboard-ReloadButton"
		>
			{t('app.reload')}
		</ReloadButton>
	)
}
